import React, { useContext, useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router';
import { Alert } from 'reactstrap';
import { login } from '../context/authContext/apiCalls';
import { AuthContext } from '../context/authContext/AuthContext';

const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { dispatch } = useContext(AuthContext);

  useEffect(() => {
    document.title = 'PFSA | Login';
  }, []);

  const loginAuth = async (e) => {
    e.preventDefault();
    error && setError('');
    if (!email || !password) {
      return setError('Empty field/s');
    }

    const res = await login({ email, password }, dispatch);

    if (res.status === 200) {
      window.location.replace(`${process.env.PUBLIC_URL}`);
    } else if (res.status === 404) {
      setError('Internal Error, please try again later');
    } else {
      setError(res.data.message);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img src={`${process.env.PUBLIC_URL}/pf-logo.svg`} width="300" alt="" />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>LOGIN</h4>
                          <h6>{'Enter your Email and Password'} </h6>
                        </div>
                        <form className="theme-form" onSubmit={loginAuth}>
                          <div className="form-group">
                            <label className="col-form-label pt-0">Email</label>
                            <input
                              className="form-control"
                              type="email"
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder="Email address"
                            />
                          </div>
                          <div className="col-md-3"></div>
                          <div className="form-group">
                            <label className="col-form-label">Password</label>
                            <input
                              className="form-control"
                              type="password"
                              name="password"
                              value={password}
                              placeholder="*****"
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                          <a className="btn-link text-capitalize" href={`${process.env.PUBLIC_URL}/reset-password`}>
                            Forgot Password?
                          </a>
                          <div className="form-group form-row mt-3 mb-0">
                            <Alert isOpen={!!error} color="danger dark col-12 mt-1 text-center">
                              {error}
                            </Alert>
                            <button className="btn btn-primary btn-block col-12" type="submit">
                              Login
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- login page end--> */}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Signin);
